export default __webpack_public_path__ + "static/media/adgitm.366e6e1d.jpg";